import { fetchAllConceptsByName } from "api-proxy/private/findConceptsByName";
import { postConcept } from "api-proxy/external/postConcept";
import { ApiConcept } from "types/swagger/clarifai-api";
import { createValidConceptNameIdSet } from "utils/concepts";

export type ConceptCreateResponse = {
    isExisting: boolean;
    concept: ApiConcept;
}

export type CreateConceptRequest = {
  request: {
    userOrOrgId: string;
    appId: string;
  };
  concept: ApiConcept;
};


// Public Endpoint to use in the app
export const createConcept = async ({ request, concept }: CreateConceptRequest): Promise<ConceptCreateResponse | null> => {
    if (!concept?.name) return null;

    // We check if we have concept in the current userId/appId
    const existingConcepts = await fetchAllConceptsByName({
        request,
        conceptName: concept.name,
        onlyCurrentAppConcepts: true,
    });

    const hasExistingConcepts = !!existingConcepts?.length;
    const existingConceptById = !!concept?.id && hasExistingConcepts ? existingConcepts.find((c) => c?.id && c.id === concept.id) : undefined;
    const existingConceptByName = hasExistingConcepts ? existingConcepts.find((c) => c?.name && c.name === concept.name) : undefined;
    // Existance by ID has priority
    const existingConcept = existingConceptById || existingConceptByName;

    if (existingConcept) {
        return {
            isExisting: true,
            concept: existingConcept,
        };
    }

    // Otherwise create a new one
    let { id, name } = createValidConceptNameIdSet(concept.name);
    // Allow overwriting the conceptId
    if (concept?.id) id = concept.id;
    const newConcept = await postConcept({ request, concept: {
        id,
        name,
        app_id: request.appId,
        user_id: request.userOrOrgId,
    }})

    if (newConcept) {
        return {
            isExisting: false,
            concept: newConcept,
        };
    }

    return null;
};
